import { NoId } from 'app/tools/general.types';
import { Merge } from 'type-fest';
import { ProductCategory } from '../product/api-product.types';

export type CompanyDetailsPt1 = {
  name: string;
  displayName?: string;
  companyNumber?: string;
  vatNumber?: string;
  phone: string;
  website?: string;
};

export type CompanyBankDetails = {
  accountholdername: string;
  accountnumber: string;
  confirmaccountnumber?: string;
  sortcode?: string;
  bankname?: string;
  currency: string;
  accountholdertype: string;
};

export type Address = {
  userDisplayLocationName?: string;
  addrLine1: string;
  addrLine2?: string;
  city: string;
  country: string;
  postcode: string;
};

export type Company = {
  id: 3;
  name: string;
  displayName?: string;
  companyNumber?: string;
  vatNumber?: string;
  phone?: string;
  website?: string;
  addrLine1: string;
  addrLine2?: string;
  city: string;
  postcode: string;
  country: string;
  logo?: string;
  companyacctype?: string;
};

export type CalendarData = {
  repairId: number;
  customerName: string;
  date?: string;
  time?: string;
  deliveryType?: string;
  itemDetails: CalendarItemDetails;
  userDetails: CalendarUserDetails;
};
export type CalendarWidgetDto = {
  id: number;
  title: string;
  from: string;
  to: string;
  color: string;
};
export type CalendarItemDetails = {
  productName: string;
  issueType: string;
};

export type CalendarUserDetails = {
  customerName: string;
  mobile: string;
  address: string;
  userProfilePhoto: string;
};

export type NotificationData = {
  chatData: NotificationChatData[];
  calenderData: NotificationCalendarData[];
};

export type NotificationCount = {
  count: string;
};

export type NotificationChatData = {
  customerName: string;
  date: string;
  time: string;
  id: number;
  productName: string;
  imageUrl: string;
  userProfilePhoto: string;
};

export type NotificationCalendarData = {
  customerName: string;
  type: string;
  date: string;
  time: string;
  id: number;
  imageUrl: string;
};

export type PageDetails = {
  pagename?: string;
};

type LogoToFileType<T> = Merge<T, { logo?: File } | { logo?: null }>;

export type CreateCompanyReq = LogoToFileType<NoId<Company>>;
export type UpdateCompanyReq = LogoToFileType<
  Partial<CreateCompanyReq>
>;

export type RepairCapability = {
  id: number;
  repairer: number;
  location?: number; // TODO: check if this is the right type
  productCategory: number;
  productCategoryDetails: ProductCategory;
};

export type SetRepairCapabilitiesReq = {
  repairCategoryIds: number[];
};

export const COMPANY_ADDRESS_KEYS: (keyof Address)[] = [
  'addrLine1',
  'addrLine2',
  'city',
  'postcode',
  'country',
];

type RequiredKeys<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? K : never;
  }[keyof T],
  undefined
>;
export const CREATE_COMPANY_REQ_KEYS: RequiredKeys<CreateCompanyReq>[] =
  ['name', 'addrLine1', 'city', 'postcode', 'country'];
